import React, { lazy, memo } from 'react';
import { Switch, Route } from 'react-router-dom';

const CalculationsDashboard = lazy(() => import('../views/CalculationsDashboard'));
const Timing = lazy(() => import('../views/Timing'));
const NoMatch = lazy(() => import('../views/NoMatch'));

const CalculationsRouts = ({ url }) => (
  <Switch>
    <Route exact path={[`${url}/:folderId`, `${url}`]}>
      <CalculationsDashboard url={url} />
    </Route>

    <Route exact path={`${url}/:folderId/:timingId`}>
      <Timing />
    </Route>

    <Route exact path={`${url}/*`}>
      <NoMatch />
    </Route>
  </Switch>
);

export default memo(CalculationsRouts);
